import api from '@Services/api';
import { Course } from '@Services/students/students.res.types';
import { AxiosResponse } from 'axios';
import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from 'src/base/services/services.base';

interface CourseTabCRUD extends CRUDBase<Course, Course> {}
export class CourseTabRequester implements CourseTabCRUD {
	private static instance: CourseTabRequester;
	static getInstance() {
		if (!CourseTabRequester.instance) {
			CourseTabRequester.instance = new CourseTabRequester();
		}
		return CourseTabRequester.instance;
	}
	baseURL = 'user/profile';
	getAll(payload?: GetAllMeta): Promise<AxiosResponse<ApiResponse<Course[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<Course[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<Course[]>>> {
		return await api.post(`${this.baseURL}/${payload.id}/courses`, payload);
	}

	async export(payload: GetAllMeta): Promise<AxiosResponse<string>> {
		return await api.post(`${this.baseURL}/all`, { ...payload, export: true });
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<Course>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<Course>>>;
	get(
		id: string | number,
		payload: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<Course>>>;
	async get(
		id: any,
		payload?: any
	): Promise<AxiosResponse<ApiResponse<Course>>> {
		return await api.post(`${this.baseURL}`, { uuid: id });
	}

	async create(payload: Course): Promise<AxiosResponse<ApiResponse<Course>>> {
		return await api.post(`${this.baseURL}/create`, payload);
	}
	async update(payload: Course): Promise<AxiosResponse<ApiResponse<Course>>> {
		return await api.put(`${this.baseURL}/update`, payload);
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<Course>>>;
	async delete(
		id: any,
		payload?: any
	): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.delete(`${this.baseURL}/delete`, {
			data: {
				uuid: id,
			},
		});
	}
}
